import Consent from "./Consent";

export default Consent;
